export const colorValues = {
  pink: {
    main: '#FFADC9',
    light: '#FFD6E4',
    dark: '#E6739A',
  },
  shiraz: {
    main: '#600F1D',
    light: '#7A2634',
    dark: '#430A15',
  },
  orange: {
    main: '#FF481F',
    light: '#FF7A58',
    dark: '#CC2D09',
  },
  navy: {
    main: '#101476',
    light: '#3B3EA0',
    dark: '#08094A',
  },
  eucalypt: {
    main: '#5EFDC5',
    light: '#A2FFDF',
    dark: '#36C69C',
  },
  brown: {
    main: '#554617',
    light: '#7A6731',
    dark: '#362C0C',
  },
  blue: {
    main: '#5DDCF2',
    light: '#A5EFFA',
    dark: '#2BA9BE',
  },
  velvet: {
    main: '#47003E',
    light: '#6A2A63',
    dark: '#2E0027',
  },
  green: {
    main: '#B9DF00',
    light: '#D6FF4C',
    dark: '#7FA600',
  },
  black: {
    main: '#111111',
    light: '#3A3A3A',
    dark: '#000000',
  },
  white: {
    main: '#FFFFFF',
    light: '#FFFFFF',
    dark: '#E6E6E6',
  },
  cream: {
    main: '#E3E3CC',
    light: '#F3F3E2',
    dark: '#C0C0A8',
  },
};
